import React, { useCallback, useEffect, useState } from 'react';
import { ArrowChevronDownIcon, CheckIcon, Icon, Menu, Typography } from '@klickly/front-packages';
import { inject, observer } from 'mobx-react';
import { Body, Item, Styles, Target } from './styles';

export const Sorting = inject('store')(
    observer(({ store }) => {
        const [state, setState] = useState();
        const { query, selectSorting: onSelect } = store.marketplaceStore;
        const { hiddenSections } = store.publisherStore;
        const { sort } = query;
        const allSectionsHidden = hiddenSections ? Object.values(hiddenSections).every((s) => s === true) : false;

        useEffect(() => {
            const selected = sort.find((item) => item.checked);

            setState(selected);
        }, [sort, state, setState]);

        const onSelected = useCallback(
            (newState) => {
                if (newState.key === state.key) {
                    return;
                }

                setState(newState);
                onSelect(newState);
            },
            [state, onSelect]
        );

        const dropdownRender = (menus) => <Body>{menus}</Body>;

        return (
            <Styles $allSectionsHidden={allSectionsHidden}>
                <Menu.Dropdown
                    dropdownRender={dropdownRender}
                    items={sort.map((item) => ({
                        key: item.key,
                        label: (
                            <Item onClick={() => onSelected({ ...item, checked: true })}>
                                <div>
                                    <Typography.Text type='badgeMedium' as='span'>
                                        {item.type}
                                    </Typography.Text>
                                    &nbsp;
                                    <Typography.Text type='descriptor1' as='span'>
                                        {item.name}
                                    </Typography.Text>
                                    &nbsp;
                                </div>
                                {item.checked && <Icon component={() => <CheckIcon />} />}
                            </Item>
                        )
                    }))}
                >
                    <Target>
                        <Typography.Text type='badgeMedium' as='span'>
                            {state?.type}
                        </Typography.Text>
                        &nbsp;
                        <Typography.Text type='descriptor1' as='span'>
                            {state?.name}
                        </Typography.Text>
                        &nbsp;
                        <Icon component={() => <ArrowChevronDownIcon />} />
                    </Target>
                </Menu.Dropdown>
            </Styles>
        );
    })
);
